
import { useEffect, useRef, useState } from "react";
import MolGrid from "../../../components/Grid/MolGrid";
import { CommitteeBatchApprovalConfig } from "../data/CommitteeBatchApprovalConfig";
import { useCommitteeApprovalListMutation } from "../../../app/services/CommitteeApprovalManagement/CommitteApprovalManagementApi";
import { useNavigate } from "react-router-dom";
import { encryptAESID } from "../../../utils/Encryption";

const CommitteeBatchApprovalList = () => {
  const molGrifRef = useRef();
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState();
  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const [committeeApprovalList, { isSuccess: isSuccessCommitteeApprovalList, isLoading: isLoadingCommitteeApprovalList, data: getCommitteeApprovalDataResponse, },] = useCommitteeApprovalListMutation();
  useEffect(() => {
    committeeApprovalList(paginationRequest);
  }, []);

  useEffect(() => {
   
    if (!isLoadingCommitteeApprovalList && isSuccessCommitteeApprovalList && getCommitteeApprovalDataResponse) {
      console.log(getCommitteeApprovalDataResponse,"aaa")
      setPaginationRequest((prev) => ({
        ...prev,
      }));
      setDataSource(getCommitteeApprovalDataResponse?.itemList);
    }
  }, [isLoadingCommitteeApprovalList, isSuccessCommitteeApprovalList, getCommitteeApprovalDataResponse,]);

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    setPaginationRequest(updatedPaginationRequest);
    committeeApprovalList(updatedPaginationRequest);
  };

  const handleView = (data) =>{
    navigate(`/viewCommitteeBatchApproval/${encryptAESID(data.batchNumber)}`)
  }
  const actionHandler = {
    View : handleView
  }
  return (<>
    <div>
      <MolGrid
          ref={molGrifRef}
         dataSource={dataSource}
        configuration={CommitteeBatchApprovalConfig}
        allowPagination={true}
        isLoading={isLoadingCommitteeApprovalList}
        pagination={paginationRequest}
        onPageChange={handlePageChange}
        onActionChange={actionHandler}
      />
    </div>
  </>)
}
export default CommitteeBatchApprovalList;